import React from "react";
import Link from "../Link";
import right4 from "../../img/right-4@2x.svg";
import rect6518 from "../../img/rectangle-6518@2x.svg";
import vect9 from "../../img/vector-19@2x.svg";
import "./RunOptimalPlan.css";

const RunOptimalPlanButton = () => {

    return (
        <Link href="/lifestrategy">
            <div className="overlap-group4-2">
                <img className="right-40" src={right4} />
                <div className="run-my-optimal-plan-1 nunito-bold-azure-radiance-14px">Run my optimal plan</div>
            </div>
            <img className="rectangle-6517-1" src={rect6518} />
            <img className="vector-67" src={vect9} />
        </Link>
    )
}

export default RunOptimalPlanButton;